import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import es_ES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

import { AuthProvider, useAuth } from './context/AuthContext';
import { SoftphoneProvider } from './context/SoftphoneContext';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CallCenterPage from './pages/CallCenterPage';
import ReportsPage from './pages/ReportsPage';

// Configurar dayjs en español globalmente
dayjs.locale('es');

// Protected Route Wrapper
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
  }

  return isAuthenticated ? <MainLayout /> : <Navigate to="/login" />;
};

function App() {
  return (
    <ConfigProvider
      locale={es_ES}
      theme={{
        token: {
          colorPrimary: '#E60000',
          borderRadius: 4
        },
        components: {
          Button: {
            fontSizeLG: 14,
            controlHeightLG: 36,
          }
        }
      }}
    >
      <AuthProvider>
      <SoftphoneProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/callcenter" element={<CallCenterPage />} />
              <Route path="/reports" element={<Navigate to="/reportes" replace />} />
              <Route path="/reportes" element={<ReportsPage />} />
              {/* Dynamic routes will be handled by the Sidebar navigation logic */}
              <Route path="*" element={<div>Página no encontrada o en construcción</div>} />
            </Route>
          </Routes>
        </Router>
      </SoftphoneProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
